<div class="trial-button">
  <div class="days column">
    <span [ngClass]="{'label-number':true, 'active': active ? active : false}">{{trial?.duration}}</span>
    <span [ngClass]="{'label-text':true, 'active': active ? active : false}">{{'eos-tv-shop-ii.lbl.trial-comparison-days'
    | translate | uppercase}}</span>
    <img src="{{trial?.logoUrl}}">
  </div>
</div>
<div [ngClass]="{'border-bottom':!active, 'border-bottom-active': active ? active : false}"></div>
